/* unplugin-vue-components disabled */import script from "./withdraw.vue?vue&type=script&setup=true&lang=js"
export * from "./withdraw.vue?vue&type=script&setup=true&lang=js"

import "./withdraw.vue?vue&type=style&index=0&id=2d5aa53c&lang=scss"

const __exports__ = script;

export default __exports__